import { IconButton } from "material-ui";
import LinkIcon from "material-ui/svg-icons/content/link";

const BUTTON_STYLE = {
  width: 30,
  height: 20,
  padding: 0,
  verticalAlign: -6,
  zIndex: 999
};

const ICON_STYLE = {
  width: 20,
  height: 20,
  color: "rgba(0,0,0,0.5)"
};

const TOOLTIP_STYLE = {
  marginTop: -30,
  userSelect: "none"
};

const InlineLinkIconButton = ({
  tooltip,
  onTouchTap,
  iconComponent = <LinkIcon />,
  iconStyle,
  style,
  ...rest
}) => {
  return (
    <IconButton
      style={Object.assign({}, BUTTON_STYLE, style)}
      iconStyle={Object.assign({}, ICON_STYLE, iconStyle)}
      tooltip={tooltip}
      tooltipStyles={TOOLTIP_STYLE}
      onTouchTap={onTouchTap}
      {...rest}
    >
      {iconComponent}
    </IconButton>
  );
};

export default InlineLinkIconButton;



// WEBPACK FOOTER //
// ./src/app/components/partials/inline-link-icon-button.jsx